module.exports = __webpack_public_path__ + "img/blueprints-desktop.ffbbea1a.jpg";